import {
  EXPERIMENT,
  FEATURE_FLAG_QUERY_KEY
} from '@/global/constants/reactQueryKeys'

export const makeExperimentKey = ({
  userId,
  namespace,
  keys
}: {
  userId?: string
  namespace: string
  keys: Array<string>
}) => {
  return [...EXPERIMENT, ...(userId ? [userId] : []), namespace, keys.sort()]
}

export const makeFeatureFlagKey = ({
  namespace,
  key
}: {
  namespace: string
  key: string
}) => {
  return [...FEATURE_FLAG_QUERY_KEY, namespace, key]
}
